import { type ReactNode } from 'react';
import {
  Stack,
  Hidden,
  Typography,
  Box,
  type Breakpoint,
  Link,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import { Strings } from '@app/constants';
import { Logo, SideIllustration } from '@app/components';
import { StyledContent, StyledCopyright } from './styles';

// --------------------------------------------------------------

interface Props {
  children: ReactNode;
  title: string;
}

const hideIllustrationBreakpoints: Breakpoint[] = ['xs', 'sm'];
const showLogoBreakpoints: Breakpoint[] = ['lg', 'md', 'xl'];

const AuthLayout = ({ children }: Props) => {
  const theme = useTheme();
  return (
    <>
      <Stack
        direction="row"
        flex={1}
        overflow="auto"
        sx={{
          background: { xs: 'none', md: `url(/assets/background/auth-bg.png) center center/contain` },
        }}
      >
        <Hidden only={hideIllustrationBreakpoints}>
          <Box width="50%">
            <SideIllustration />
          </Box>
        </Hidden>

        <StyledContent>
          <Hidden only={showLogoBreakpoints}>
            <Stack
              alignSelf="center"
              sx={{
                background: {
                  md: 'none',
                  xs: `url(/assets/background/auth-bg.png) center/contain`,
                  width: 140,
                  borderRadius: '10px',
                  marginBottom: 50,
                },
              }}
            >
              <Logo disabledLink sx={{ img: { width: 140 } }} />
            </Stack>
          </Hidden>

          {children}
          <Typography variant="body2" alignSelf={'center'} textAlign={'center'} mt={2}>
            {Strings.common.choosingToRegister}
            <Link
              color="inherit"
              // href={PATH_AUTH.signUp}
              sx={{ fontWeight: 'bold' }}
            >
              {Strings.common.termsConditions}
            </Link>
          </Typography>
        </StyledContent>
      </Stack>
    </>
  );
};
export { AuthLayout };
